import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardBody } from "reactstrap"

const CvmListRenderer = ({ apiResponse }) => {
  const resultData = apiResponse?.resultData;
  
  if (!resultData?.items) return null;

  const cvmItems = resultData.items.map((item, index) => (
    <Card key={`cvm-item-${index}`} className="mb-3" style={{ border: '1px solid #e6e6e6' }}>
      <CardBody>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
          <h5 style={{ color: '#013f7c', fontSize: '14px', margin: 0 }}>
            {item.byte1.method.label}
          </h5>
          <span style={{ 
            backgroundColor: 'rgb(52, 195, 143)', 
            color: 'white', 
            padding: '4px 8px', 
            borderRadius: '4px', 
            fontSize: '12px',
            fontWeight: 'bold'
          }}>
            {item.dataElement}
          </span>
        </div>
        
        <div style={{ color: '#013f7c', fontSize: '13px', marginBottom: '8px' }}>
          <strong>Condition:</strong> {item.byte2.label}
        </div>
        
        <div style={{ color: '#013f7c', fontSize: '12px' }}>
            <span>{item.byte1.bit7IfUnsuccessful.label}</span>
        </div>
      </CardBody>
    </Card>
  ));

  return (        
    <div>
      <h5 style={{ marginBottom: '15px', color: '#495057' }}>CVM List Items:</h5>
      {cvmItems}
    </div>
  );
};

CvmListRenderer.propTypes = {
  apiResponse: PropTypes.object.isRequired
}

export default CvmListRenderer